import { render } from "./Home.vue?vue&type=template&id=15968fb4"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manzurul\\AppData\\Local\\Jenkins.jenkins\\workspace\\Course-Manager-Support-Production\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__